import { useState, useCallback, useEffect } from "react";
import {
  ReactFlow,
  applyNodeChanges,
  applyEdgeChanges,
  addEdge,
  MarkerType,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { theme } from "../../config/theme";
import CustomNode from "./CustomNode";
import { CustomEdge } from "./CustomEdge";

const initialNodes = [
  { id: "n1", position: { x: 0, y: 0 }, data: { label: "Node 1" } },
  { id: "n2", position: { x: 0, y: 100 }, data: { label: "Node 2" } },
];
const initialEdges = [{ id: "n1-n2", source: "n1", target: "n2" }];

export default function ValidationFlowChart({ data }) {
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  console.log(data);

  useEffect(() => {
    if (data) {
      let newNodes = [];
      let newEdges = [];
      let c = -1;
      while (c < data?.length) {
        newNodes.push({
          type: "customNode",
          id: String("node-" + (c + 1)),
          position: { x: (c + 1) * 300, y: 0 },
          data: {
            label: c === -1 ? "Start" : data[c].logic,
          },
        });
        if (c >= 0) {
          newEdges.push({
            id: c + "-" + (c + 1),
            type: "customEdge",
            source: String("node-" + c),
            target: String("node-" + (c + 1)),
            markerEnd: {
              type: MarkerType.ArrowClosed,
              width: 20,
              height: 20,
              color: "#FF0072",
            },
          });
        }
        c++;
      }

      let end = c + 1;
      newNodes.push({
        type: "customNode",
        id: String("node-y-" + end),
        position: { x: end * 300, y: -100 },
        data: {
          label: "Yes",
        },
      });
      newNodes.push({
        type: "customNode",
        id: String("node-n-" + end),
        position: { x: end * 300, y: +100 },
        data: {
          label: "No",
        },
      });
      newNodes.push({
        type: "customNode",
        id: String("node-" + (end + 1)),
        position: { x: (end + 1) * 300, y: 0 },
        data: {
          label: "End",
        },
      });

      newEdges.push({
        id: Number(end) + "-y-" + Number(end + 1),
        type: "customEdge",
        source: String("node-" + Number(c)),
        target: String("node-y-" + end),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 20,
          height: 20,
          color: "#FF0072",
        },
      });
      newEdges.push({
        id: Number(end) + "-n-" + Number(end + 2),
        type: "customEdge",
        source: String("node-" + Number(c)),
        target: String("node-n-" + end),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 20,
          height: 20,
          color: "#FF0072",
        },
      });

      newEdges.push({
        id: Number(end) + "-y-" + Number(end + 3),
        type: "customEdge",
        source: String("node-y-" + end),
        target: String("node-" + (end + 1)),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 20,
          height: 20,
          color: "#FF0072",
        },
      });
      newEdges.push({
        id: Number(end) + "-n-" + Number(end + 4),
        type: "customEdge",
        source: String("node-n-" + end),
        target: String("node-" + (end + 1)),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: 20,
          height: 20,
          color: "#FF0072",
        },
      });

      console.log("FLOW", newNodes, newEdges);
      setNodes(newNodes);
      setEdges(newEdges);
    }
  }, [data]);

  const onNodesChange = useCallback(
    (changes) =>
      setNodes((nodesSnapshot) => applyNodeChanges(changes, nodesSnapshot)),
    [],
  );
  const onEdgesChange = useCallback(
    (changes) =>
      setEdges((edgesSnapshot) => applyEdgeChanges(changes, edgesSnapshot)),
    [],
  );
  const onConnect = useCallback(
    (params) => setEdges((edgesSnapshot) => addEdge(params, edgesSnapshot)),
    [],
  );

  console.log(data, nodes, edges);

  return (
    <div style={{ width: "100%", height: "80%" }}>
      <ReactFlow
        // style={{ backgroundColor: theme.palette.secondary.light }}
        nodes={nodes}
        nodeTypes={{ customNode: CustomNode }}
        edgeTypes={{ customEdge: CustomEdge }}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView
      />
    </div>
  );
}
